import eCommerce from "../assets/e-commerce.png";
import videoLib from "../assets/innotion-watch.png";
import notesfeed from "../assets/notesfeed.png";
import uiLibrary from "../assets/ui-library.png";
import chimes from "../assets/chimes.png";
import coloors from "../assets/coloors.png";
import magnum from "../assets/magnum.png";
import beatmaker from "../assets/beatmaker.png";
import quiz from "../assets/quiz.png";

const userData = {
  projects: [
    {
      _id: 0,
      title: "inNotion Watch - Video Library",
      description: "Video library with categorized self-care videos.",
      link: "https://innotion-watch.netlify.app/",
      repoLink: "https://github.com/nayyyhaa/inNotion-watch",
      img: videoLib,
      tech: ["React", "Redux Toolkit", "MockBee"],
    },
    {
      _id: 1,
      title: "inNotion Care - Ecommerce App",
      description: "E-Commerce App that sells self-care products.",
      link: "https://innotion-carev2.netlify.app",
      repoLink: "https://github.com/nayyyhaa/inNotion-care-react",
      img: eCommerce,
      tech: ["React", "useContext + useReducer", "MockBee"],
    },
    {
      _id: 2,
      title: "NotesFeed - Note making App",
      description: "Manage your daily tasks & workflow in modern way.",
      link: "https://notesfeed.netlify.app",
      repoLink: "https://github.com/nayyyhaa/NotesFeed",
      img: notesfeed,
      tech: ["React", "MockBee"],
    },
    {
      _id: 3,
      title: "inNotion Quiz - Quiz App",
      description: "Quiz application to check your knowledge on your self-care journey.",
      link: "https://innotion-quiz-react.netlify.app/",
      repoLink: "https://github.com/nayyyhaa/innotion-quiz-react",
      img: quiz,
      tech: ["React", "Typescript", "Firebase"],
    },
    {
      _id: 4,
      title: "inNotion UI Library",
      description: "Customised & roburst component library to build you website.",
      link: "https://innotion-ui.netlify.app",
      repoLink: "https://github.com/nayyyhaa/inNotion-UI",
      img: uiLibrary,
      tech: ["HTML", "CSS", "JavaScript"],
    },
    {
      _id: 5,
      title: "Chimes - Music App",
      description: "Music player app with integrated library.",
      link: "https://chimes.netlify.app",
      repoLink: "https://github.com/nayyyhaa/chimes-music-app",
      img: chimes,
      tech: ["React"],
    },
    {
      _id: 6,
      title: "Coloors Clone",
      description: "Generate aesthetic & customised color pallete.",
      link: "https://colorsplash.netlify.app",
      repoLink: "https://github.com/nayyyhaa/my-color-palette",
      img: coloors,
      tech: ["HTML", "CSS", "JavaScript"],
    },
    {
      _id: 7,
      title: "Magnum",
      description:
        "Game searching platform to get details about new, most popular and upcoming video games across all gaming platforms.",
      link: "https://magnum-games.netlify.app/",
      repoLink: "https://github.com/nayyyhaa/magnum",
      img: magnum,
      tech: ["React", "Redux"],
    },
    {
      _id: 8,
      title: "Make my music",
      description: "Beatmaker app with audio controls.",
      link: "https://makemymusic.netlify.app/",
      repoLink: "https://github.com/nayyyhaa/make-my-music",
      img: beatmaker,
      tech: ["HTML", "CSS", "JavaScript"],
    },
  ],
  footer: [
    {
      _id: 1,
      title: "Blogs",
      tag: "blogs",
      data: [
        {
          _id: 1,
          title: "Everything you need to know about Execution Context in JavaScript",
          link: "https://dev.to/nayyyhaa/everything-you-need-to-know-about-execution-context-in-javascript-2jha",
        },
        {
          _id: 2,
          title: "Build your own Shakespeare Translation Web App with JavaScript Fetch API",
          link: "https://dev.to/nayyyhaa/build-your-own-shakespeare-translation-web-app-with-javascript-fetch-api-loo",
        },
        {
          _id: 3,
          title: "Let's talk about CSS Box Model",
          link: "https://dev.to/nayyyhaa/css-box-model-ibg",
        },
      ],
    },
    {
      _id: 2,
      title: "Socials",
      tag: "socials",
      data: [
        { _id: 1, title: "LinkedIn", icon: "fa fa-linkedin", link: "https://www.linkedin.com/in/nayyyhaa/" },
        { _id: 2, title: "Github", icon: "fa fa-github", link: "https://www.github.com/nayyyhaa" },
        { _id: 3, title: "Twitter", icon: "fa fa-twitter", link: "https://www.twitter.com/nayyyhaa" },
        { _id: 4, title: "Instagram", icon: "fa fa-instagram", link: "https://www.instagram.com/nehacode" },
        { _id: 5, title: "Dev.to", icon: "fa fa-book", link: "https://dev.to/nayyyhaa" },
        { _id: 6, title: "CodeSandBox", icon: "fa fa-code", link: "https://codesandbox.io/u/nayyyhaa" },
      ],
    },
    { _id: 3, title: "Say Hi", tag: "connect" },
  ],
};

export default userData;
